export const m6l0Solution = `%lang starknet

// References in Cairo are like aliases to specific memory cells pointed by ap

// TODO: complete the bar function to make the test pass
// You will encounter a "revoked reference" error
// https://www.cairo-lang.org/docs/how_cairo_works/consts.html#revoked-references

from starkware.cairo.common.cairo_builtins import HashBuiltin
from starkware.cairo.common.hash import hash2

func foo(n : felt) {
    if (n == 0) {
        return ();
    }
    foo(n=n - 1);
    return ();
}

func bar{hash_ptr : HashBuiltin*}() {
    // do not modify code on this line or above

    alloc_locals;
    local hash_ptr : HashBuiltin* = hash_ptr;

    // do not modify code on this line or below

    hash2(1, 2);
    foo(3);

    hash2(3, 4);
    return ();
}

@external
func test_bar{syscall_ptr : felt*, pedersen_ptr : HashBuiltin*, range_check_ptr}() {
    bar{hash_ptr=pedersen_ptr}();
    return ();
}`;
